/** UI preset list; stored in DB as plain text on `customerOfferHighlight` (no schema change). */

export const CUSTOMER_OFFER_PRESET_LABELS = [
  "Product Demo / Presentation",
  "Pilot Project / Trial",
  "Technical Consultation",
  "Integration Support",
  "Custom Solution Development",
  "Process Optimization Support",
  "Training & Onboarding",
  "After-Sales Support",
  "Other",
] as const;

export const CUSTOMER_OFFER_OTHER_LABEL = "Other" as const;

const NON_OTHER_PRESETS = CUSTOMER_OFFER_PRESET_LABELS.filter((l) => l !== CUSTOMER_OFFER_OTHER_LABEL);

export type CustomerOfferPresetLabel = (typeof CUSTOMER_OFFER_PRESET_LABELS)[number];

/** Values sent to API: fixed label, or free text when "Other" is chosen. */
export function serializeCustomerOfferHighlightForApi(
  preset: string,
  otherText: string
): string | null {
  const p = (preset ?? "").trim();
  if (!p) return null;
  if (p === CUSTOMER_OFFER_OTHER_LABEL) {
    const t = (otherText ?? "").trim();
    return t || null;
  }
  return p;
}

/** Split API / saved string into UI fields. Unknown text → Other + full string. */
export function parseCustomerOfferHighlightFromApi(stored: string | null | undefined): {
  preset: string;
  otherText: string;
} {
  const s = (stored ?? "").trim();
  if (!s) return { preset: "", otherText: "" };
  if ((NON_OTHER_PRESETS as readonly string[]).includes(s)) {
    return { preset: s, otherText: "" };
  }
  if (s === CUSTOMER_OFFER_OTHER_LABEL) {
    return { preset: CUSTOMER_OFFER_OTHER_LABEL, otherText: "" };
  }
  return { preset: CUSTOMER_OFFER_OTHER_LABEL, otherText: s };
}
